import { BillingInfoText } from "../BillingInformation-types";
/**
 * Column configuration for gift card table
 */
export const GIFT_CARD_COLUMN_METADATA = {
    giftCardNumber: {
        label: BillingInfoText.GIFT_CARD_NUMBER,
        minWidth: 150,
        align: "left",
        order: 1,
    },
    initialValue: {
        label: BillingInfoText.GIFT_CARD_STARTING_BALANCE,
        minWidth: 130,
        align: "right",
        order: 2,
    },
    balance: {
        label: BillingInfoText.GIFT_CARD_BALANCE,
        minWidth: 130,
        align: "right",
        order: 3,
    },
    sender: {
        label: BillingInfoText.GIFT_CARD_SENDER,
        minWidth: 120,
        align: "left",
        order: 4,
    },
    createdOn: {
        label: BillingInfoText.GIFT_CARD_CREATED,
        minWidth: 100,
        align: "left",
        order: 5,
    },
    actions: {
        label: "More",
        minWidth: 80,
        align: "center",
        order: 6,
    },
};
